export const fetchDomAttribute = (key: string): string | null | undefined => {
  const div = document.getElementById('app')
  const value = div?.getAttribute(key)
  return value
}
